import * as React from 'react';
import PropTypes from 'prop-types';
var SvgAchievementsMedalPrSmall = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.577 6.851A7.995 7.995 0 0112 22 7.995 7.995 0 018.425 6.851L6.067 1.708A.5.5 0 016.522 1H17.48a.5.5 0 01.455.708L15.577 6.85zm-.914-.405L16.7 2h-4.076l2.038 4.446zM7.3 2l2.044 4.46a7.759 7.759 0 014.075-.329L11.526 2H7.3zm-.606 15h1.25v-2.51h1.55c1.51 0 2.41-.83 2.41-2.24 0-1.39-.92-2.25-2.4-2.25h-2.81v7zm1.25-3.66v-2.19h1.53c.78 0 1.18.36 1.18 1.1 0 .7-.43 1.09-1.18 1.09h-1.53zm8.29.94c.95-.28 1.51-1.03 1.51-2.09 0-1.36-.9-2.19-2.37-2.19h-2.74v7h1.25v-2.6h1.06l1.39 2.6h1.37l-1.47-2.71v-.01zm-2.35-1.03v-2.1h1.35c.83 0 1.26.35 1.26 1.04 0 .69-.44 1.06-1.26 1.06h-1.35z"
  }));
});
SvgAchievementsMedalPrSmall.defaultProps = {
  height: 24,
  width: 24
};
SvgAchievementsMedalPrSmall.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgAchievementsMedalPrSmall;